// extracted by mini-css-extract-plugin
export default {"root":"styles_root__1ugmG","add-tab":"styles_add-tab__utNdu","plus-icon":"styles_plus-icon__ec9Vb"};